import Heading from 'common/components/Heading';
import { AppState } from 'interactive/hooks/useAppState';
import { LogoType, LogoTypeKey } from 'interactive/logo-types';
import VelocityScrollable from 'marketing/components/velocity-scrollable';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

interface Props {
    currentValue?: LogoTypeKey[];
    types: LogoType[];
    onSelect(key: LogoTypeKey): AppState;
    onDeSelect(key: LogoTypeKey): AppState;
}

const LogoTypesSelect = ({ currentValue = [], onDeSelect, onSelect, types }: Props) => {
    const scrollContainer = useRef<HTMLDivElement>(null);
    const container = useRef<HTMLDivElement>(null);
    const [containerStyles, setContainerStyles] = useState({});

    useEffect(() => {
        if (container.current) {
            // tslint:disable-next-line:no-unused-expression
            new VelocityScrollable(
                container.current,
                document.documentElement!,
                window.requestAnimationFrame.bind(window) as Function,
                { threshold: 500 }
            );
        }
    }, []);

    useLayoutEffect(() => {
        if (container.current && scrollContainer.current) {
            const diff = scrollContainer.current.clientHeight - container.current.clientHeight;

            if (diff > 0) {
                setContainerStyles({
                    bottom: -1 * diff + 'px',
                    marginTop: -1 * diff + 'px',
                });
            }
        }
    });

    return (
        <div ref={scrollContainer} style={{ overflow: 'hidden' }}>
            <div
                ref={container}
                className="get-started-interactive-content get-started-interactive-content--logo-types"
                style={containerStyles}
            >
                <div className="get-started-interactive-content__inner">
                    {types.map(t => (
                        <div className="get-started-interactive-content__inner__item" key={t.key}>
                            <label
                                className="input-card input-card--logo-type"
                                htmlFor={`checkbox-logo-type-${t.key}`}
                            >
                                <input
                                    type="checkbox"
                                    name="logo-type"
                                    value={t.key}
                                    id={`checkbox-logo-type-${t.key}`}
                                    checked={currentValue.includes(t.key)}
                                    onChange={({ target: { checked, value } }) =>
                                        checked
                                            ? onSelect(value as LogoTypeKey)
                                            : onDeSelect(value as LogoTypeKey)
                                    }
                                />
                                <span className="input-card__card">
                                    <img src={t.imageSrc} />

                                    <Heading size="h5" variations={['heading--quarter-margin']}>
                                        {t.title}
                                    </Heading>

                                    <span className="paragraph paragraph--small paragraph--soft paragraph--no-margin">
                                        {t.description}
                                    </span>

                                    {t.attribution && (
                                        <span className="attribution attribution--small">
                                            {t.attribution}
                                        </span>
                                    )}
                                </span>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LogoTypesSelect;
